<template>
  <div id="protocol">
    <template v-if="passengerTableData.length > 0">
      <div class="formTitle">乘客端协议</div>
      <el-table :data="passengerTableData" border style="width: 820px">
        <el-table-column prop="title" label="协议标题" min-width="150"></el-table-column>
        <el-table-column label="协议说明" min-width="300">
          <template slot-scope="scope">
            {{ mixinUserInfo.platformType === 3 ? scope.row.remark : $const.PROTOCOLTYPE.get(scope.row.usePage).tips }}
          </template>
        </el-table-column>
        <el-table-column label="是否启用" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="statusChange($event, scope.row)" :active-value="1"
                       :inactive-value="2" :disabled="$const.PROTOCOLTYPE.get(scope.row.usePage).disabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button @click="editProtocol(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="previewProtocol(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="driverTableData.length > 0">
      <div class="formTitle">司机端协议</div>
      <el-table :data="driverTableData" border style="width: 820px">
        <el-table-column prop="title" label="协议标题" min-width="150"></el-table-column>
        <el-table-column label="协议说明" min-width="300">
          <template slot-scope="scope">
            {{ mixinUserInfo.platformType === 3 ? scope.row.remark : $const.PROTOCOLTYPE.get(scope.row.usePage).tips }}
          </template>
        </el-table-column>
        <el-table-column label="是否启用" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="statusChange($event, scope.row)" :active-value="1"
                       :inactive-value="2" :disabled="$const.PROTOCOLTYPE.get(scope.row.usePage).disabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button @click="editProtocol(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="previewProtocol(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="mobileTableData.length > 0">
      <div class="formTitle">移动售票端协议</div>
      <el-table :data="mobileTableData" border style="width: 820px">
        <el-table-column prop="title" label="协议标题" min-width="150"></el-table-column>
        <el-table-column label="协议说明" min-width="300">
          <template slot-scope="scope">
            {{ $const.PROTOCOLTYPE.get(scope.row.usePage).tips }}
          </template>
        </el-table-column>
        <el-table-column label="是否启用" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="statusChange($event, scope.row)" :active-value="1"
                       :inactive-value="2" :disabled="$const.PROTOCOLTYPE.get(scope.row.usePage).disabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button @click="editProtocol(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="previewProtocol(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template v-if="channelTableData.length > 0">
      <div class="formTitle">渠道端协议</div>
      <el-table :data="channelTableData" border style="width: 820px">
        <el-table-column prop="title" label="协议标题" min-width="150"></el-table-column>
        <el-table-column label="协议说明" min-width="300">
          <template slot-scope="scope">
            {{ $const.PROTOCOLTYPE.get(scope.row.usePage).tips }}
          </template>
        </el-table-column>
        <el-table-column label="是否启用" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" @change="statusChange($event, scope.row)" :active-value="1"
                       :inactive-value="2" :disabled="$const.PROTOCOLTYPE.get(scope.row.usePage).disabled"></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" min-width="140">
          <template slot-scope="scope">
            <el-button @click="editProtocol(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="previewProtocol(scope.row)" type="text" size="small">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <!-- 协议预览弹窗 -->
    <el-dialog title="协议预览" :visible.sync="previewVisible" width="860px" append-to-body>
      <div style="font-size:14px;font-weight:bold;margin-bottom:8px">{{ previewRow.title }}</div>
      <div style="font-size:12px;color:#909399;margin-bottom:12px">
        版本：v{{ previewRow.version || 1 }} &nbsp;|&nbsp;
        状态：{{ previewRow.status === 1 ? '已启用' : '已禁用' }}
      </div>
      <el-tabs v-model="previewTab">
        <el-tab-pane label="全文预览" name="content">
          <div class="protocol-preview-scroll">
            <markdown-viewer v-if="isMarkdownContent(previewRow.content)" :content="previewRow.content"></markdown-viewer>
            <div v-else v-html="previewRow.content || '<p style=\'color:#909399\'>（暂无内容）</p>'"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="概述预览" name="summary">
          <div class="protocol-preview-scroll">
            <markdown-viewer v-if="isMarkdownContent(previewRow.summary)" :content="previewRow.summary"></markdown-viewer>
            <div v-else v-html="previewRow.summary || '<p style=\'color:#909399\'>（暂无概述）</p>'"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer">
        <el-button size="small" @click="previewVisible = false">关闭</el-button>
        <el-button type="primary" size="small" @click="editProtocol(previewRow); previewVisible = false">去编辑</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MarkdownViewer from "@/components/markdownViewer.vue";

export default {
  name: "protocol",
  components: { MarkdownViewer },
  data() {
    return {
      tableData: [],
      saveStatus: false,
      formProtocol: {usePage: 1, content: null, status: null},
      previewVisible: false,
      previewRow: {},
      previewTab: 'content',
    };
  },
  computed: {
    driverTableData() {
      const list = this.tableData.filter(item => this.$const.PROTOCOLTYPE.get(item.usePage)?.name === "司机端");
      return list.sort((a, b) => a.sort - b.sort)
    },
    passengerTableData() {
      const list = this.tableData.filter(item => this.$const.PROTOCOLTYPE.get(item.usePage)?.name === "乘客端");
      return list.sort((a, b) => a.sort - b.sort)
    },
    mobileTableData() {
      const list = this.tableData.filter(item => this.$const.PROTOCOLTYPE.get(item.usePage)?.name === "移动售票端");
      return list.sort((a, b) => a.sort - b.sort)
    },
    channelTableData() {
      const list = this.tableData.filter(item => this.$const.PROTOCOLTYPE.get(item.usePage)?.name === "渠道端");
      return list.sort((a, b) => a.sort - b.sort)
    },
  },
  created() {
    this.getTable();
  },
  methods: {
    // 协议列表
    async getTable() {
      let url = "/api/v1/manage/systems/userAgreement";
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.tableData = data.data;
      }
    },
    // 协议编辑
    editProtocol(row) {
      this.$router.push({path: '/protocolDetail', query: {id: row.id}});
    },
    // 协议预览
    previewProtocol(row) {
      this.previewRow = row;
      this.previewTab = 'content';
      this.previewVisible = true;
    },
    // 内容是否为 Markdown
    isMarkdownContent(content) {
      if (!content) return false;
      const mdPatterns = [/^#{1,6}\s+/m, /^[-*+]\s+/m, /^\d+\.\s+/m, /^```/m, /^>\s+/m, /\|.*\|/m];
      return mdPatterns.filter(p => p.test(content)).length >= 2;
    },

    // 协议列表状态更改
    statusChange(status, row) {
      let post = async () => {
        let url = "/api/v1/manage/systems/userAgreement/status";
        let params = {
          id: row.id,
          status: status,
        };
        let data = await this.$axios.post(url, params);
        if (data && data.code === 1) {
          this.$message.success('操作成功');
          this.getTable();
        } else {
          this.getTable();
        }
      }

      if (status == 1) {
        if (!row.content) {
          this.$message.info('请先编辑协议内容');
          row.status = status == 1 ? 2 : 1;
          return;
        }
        post();
      } else {
        this.$confirm(
            "确认" + (status == 1 ? "启用" : "关闭") + "这条协议吗？",
            status == 1 ? "启用提示" : "关闭提示"
        ).then(async () => {
          post();
        }).catch(() => {
          row.status = status == 1 ? 2 : 1;
        });
      }

    },
  },
};
</script>

<style lang="less">
#protocol {
  .blueInfo {
    width: 800px;
    display: flex;
    align-content: center;
    justify-content: space-between;

    p {
      line-height: 2;
    }
  }

  .protocol-preview-scroll {
    max-height: 520px;
    overflow-y: auto;
    padding: 4px 0;
  }
}
</style>
